import { Play } from "lucide-react";
import { useState } from "react";

const embedUrl = (url) => {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0`;
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}?autoplay=1`;
  return null;
};

export function VideoEmbed({ url, poster }) {
  const [play, setPlay] = useState(false);
  const embed = embedUrl(url);
  return (
    <div className="jc-card-img aspect-[4/5] relative bg-[#2B2522]" data-testid="founder-video">
      {play ? (
        embed ? (
          <iframe src={embed} title="Founder welcome" className="w-full h-full" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />
        ) : (
          <video src={url} poster={poster} controls autoPlay playsInline className="w-full h-full object-contain bg-black" />
        )
      ) : (
        <button type="button" onClick={() => setPlay(true)} className="group w-full h-full relative" data-testid="founder-video-play-btn" aria-label="Play founder welcome video">
          {poster ? <img src={poster} alt="" className="w-full h-full object-cover opacity-90" /> : <div className="w-full h-full bg-gradient-to-br from-[#E7C4BC] to-[#C9A97A]" />}
          <span className="absolute inset-0 flex flex-col items-center justify-center gap-4">
            <span className="w-20 h-20 rounded-full bg-[#FBF8F3]/90 flex items-center justify-center group-hover:scale-105 transition-transform duration-500">
              <Play className="w-6 h-6 ml-1 text-[#2B2522]" strokeWidth={1.25} />
            </span>
            <span className="text-[11px] uppercase tracking-[0.3em] text-[#FBF8F3]">Watch the welcome</span>
          </span>
        </button>
      )}
    </div>
  );
}
